var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { useBackgroundContext } from '../BackgroundContext/index.js';
import { ExclamationCircleIcon } from '../icons/index.js';
export const Textarea = forwardRef((props, ref) => {
    const { invalid = false, className, disabled } = props, rest = __rest(props, ["invalid", "className", "disabled"]);
    const { backgroundType, backgroundClsx, text500Clsx } = useBackgroundContext();
    const placeholderClsx = [
        backgroundType === 'main' && 'placeholder-basicMain-300',
        backgroundType === 'surface' && 'placeholder-basicSurface-300/75',
        backgroundType === 'secondary' && 'placeholder-basicSecondary-300',
    ];
    return (React.createElement("div", { className: "flex relative rounded-md shadow-sm" },
        React.createElement("textarea", Object.assign({ ref: ref, className: clsx(' block w-full rounded-md', text500Clsx, backgroundClsx, placeholderClsx, !invalid &&
                'focus:ring-actionPrimary-500 focus:border-actionPrimary-500 border-basicSurface-300/25', invalid &&
                'pr-10 border-danger-300 text-danger-900 placeholder-danger-300 focus:outline-none focus:ring-danger-500 focus:border-danger-500', disabled && 'opacity-60 cursor-default', className), rows: 4, disabled: disabled }, rest)),
        invalid && (React.createElement("div", { className: "absolute top-0 right-0 pr-3 pt-3 flex items-center pointer-events-none" },
            React.createElement(ExclamationCircleIcon, { className: "h-5 w-5 text-danger-500", "aria-hidden": "true" })))));
});
//# sourceMappingURL=Textarea.js.map